import * as z from "zod";

export const getTotalAiResponseCount = {
  name: "getTotalAiResponseCount" as const,
  input: z.object({}),
  output: z.object({ count: z.number().int().nonnegative() }),
};
